import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
//import { NgwWowService } from 'ngx-wow';
import { DataService, EmmiterService } from 'src/app/services/data.service';
import { HttpParams } from '@angular/common/http';
import { CommonService } from 'src/app/services/common.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MagnifyFieldSearchComponent } from 'src/app/shared/components/magnify-field-search/magnify-field-search.component';
// Multile Select Dropdown
import { DropdownMultiselectComponent } from 'src/app/shared/components/dropdown-multiselect/dropdown-multiselect.component';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { NavigationExtras, Router } from '@angular/router';
import { EncryptDecryptService } from 'src/app/services/encrypt-decrypt.service';
import {MemoryStorageService} from 'src/app/services/memory-storage.service';

@Component({
  selector: 'app-update-data',
  templateUrl: './update-data.component.html',
  styleUrls: ['./update-data.component.css']
})
export class UpdateDataComponent implements OnInit {
  advanceSearchFields: any = [];
  filterDocumentTypeId: any = [];
  docTypeList: any = [];
  selectedDocType: number = 0;

  modalReference: any;

  // Grid Data Model//
  selectedWorklistId: number = 1;
  advanceSearchGridData: any = [];
  advanceSearchColumnsToHide: any = ['id', 'DOCUMENT_DETAIL_ID'];
  lstURN: any = "";
  invoiceAmount: any = "";
  isOpenDoctypeModel: boolean = true;
  //Document Type Dropdown Property

  workItemFieldList: any = [];
  lstSection = [];
  lstNextQueue = [];
  lstDocument_details_id = [];

  db_columns_values_list = {};
  dependant_dropdown_list = [];
  frmInvoice: FormGroup;
  base64FileString: string = '';
  invoiceDocValidFileExtensions = [];
  invoiceDocFileSize = {};
  restrictedKeywords: any = [];

  submitted = false;
  isCommentExpand: boolean = false;
  wordsTotal: any = 1000;
  strComments: string = '';
  nextQueue = 'nextQueue';
  invoiceComment = 'invoiceComment';

  attachmentList = [];
  fileControlType = 'file'; //for SSA fixing (we have checked upload file type)
  fileName = 'Choose File';

  @ViewChild('ddlDocselect') ddlDocmultiselect: DropdownMultiselectComponent;
  @ViewChild('ddlProcessmultiselect')
  ddlProcessmultiselect: DropdownMultiselectComponent;
  @ViewChild('ddlPriority') ddlPriority: DropdownMultiselectComponent;
  @ViewChild('invFileUpload') fileInput: ElementRef;

  lstProcess: any = [];
  lstPriority: any = [
    { value: 'NORMAL', text: 'Normal' },
    // { value: 'MEDIUM', text: 'Medium' },//'Medium', arun decided to remove from the priority 
    //discussed and confirmed on 13-06-2022.
    { value: 'HiGH', text: 'High' },
  ];

  // Invoice Creation Range
  isDateRangeHasValue = false;
  maxDate = new Date();
  invoiceCreationDateRange = new FormGroup({
    start_date: new FormControl(),
    end_date: new FormControl(),
  });
  Is_Next_queue_req: boolean;

  constructor(
    //private wowService: NgwWowService,
    private dataService: DataService,
    public commonService: CommonService,
    private modalService: NgbModal,
    private route: Router,
    private encryptDecryptservice:EncryptDecryptService,
    private memorystore: MemoryStorageService
  ) {
    //wowService.init();
  }

  ngOnInit(): void {
    this.getDocumentTypes();
    this.restrictedKeywords = this.commonService.getRestrictedKeywords();
    this.getNextQueue();
    this.Is_Next_queue_req = Boolean(Number(this.dataService.Enable_Update_data_Module_Next_queue))

  }

  getDocumentTypes() {
    this.docTypeList = [];
    let params = new HttpParams();
    // params = params.append('project_id', this.commonService.selectedProject);
    // params = params.append('subgroup_id', this.commonService.selectedSubgroup);
    params = params.append('project_id', this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedProject));
    params = params.append('subgroup_id',this.encryptDecryptservice.encryptUsingAES256( this.commonService.selectedSubgroup));
    params = params.append('xusrid', this.encryptDecryptservice.encryptUsingAES256(this.memorystore.getItem('userId')));
    this.dataService.getData('document-types', params).subscribe(
      (res) => {
        if (res != null && (res.error_message == null || res.error_message == "")) {
          if (res.data != null) {
            res.data.forEach((element) => {
              this.filterDocumentTypeId.push(element.document_type_id);
              this.docTypeList.push({
                value: element.document_type_id,
                text: element.document_type_name,
                selected: true,
              });
            });
            this.selectedDocType = res.data[0].document_type_id;
          }
        }
        else {
          if (res.errorCode != 0 && res.errorCode == 4000) {
            this.route.navigateByUrl('/unauthorized');
            return;
          }
          if (res.errorCode != 0 && res.errorCode == 3000) {
            this.commonService.showMessageBox("Internal error")
          }
        }
        this.getAdvanceSearchFields();
        this.getdynamicdata();
      },
      error => {
        if (error.includes("401")) {
          this.route.navigateByUrl('/unauthorized');
          return;
        }
      }
    );
  }

  getAdvanceSearchFields() {
    this.advanceSearchFields = [];
    let reqData = {
      project_id: this.commonService.selectedProject,
      subgroup_id: this.commonService.selectedSubgroup,
      document_type_ids: this.selectedDocType.toString(),//this.filterDocumentTypeId.toString()
      source: 'updatedata'
    };
    this.dataService
      .getDataPromise('advanced-search-fields', reqData)
      .then((res) => {
        if (res != null && res.data != null) {
          this.advanceSearchFields = res.data;
          this.advanceSearchFields.forEach(async (element) => {
            element['search_value'] = '';

            if (element.control_type == 'TEXTBOX') {
              element.value_type =
                element.validation_type == 'NUMERIC' ? 'number' : 'text';
            }
            if (element.control_type == 'DROPDOWN') {
              element.options = await this.commonService.getDropdownData(
                element.field_mapping_detail_id
              );
              element.options.splice(0, 0, { id: 0, name: '-- Select --' });
            }
          });
        }
      });
  }

  openFilterFieldMagnifySearchModal(fieldMappingDetailId: number, magnifyDependantFields: string = null) {

    let dependantFieldValues = {};
    if (magnifyDependantFields != null) {
      magnifyDependantFields = JSON.parse(magnifyDependantFields);
      Object.keys(magnifyDependantFields).forEach(x => {
        let field = this.advanceSearchFields.find(f => f.db_column_name == magnifyDependantFields[x]);
        if (field != undefined) {
          let field_value = field.search_value;
          if (field_value != null && field_value != '' && field_value != undefined) {
            // if (field.control_type == 'DROPDOWN') {
            //   field_value = field.options.find(d => d.id == field_value).name;
            // }
            dependantFieldValues[x] = field_value.toString();
          }
        }

      });
    }

    const modalRef = this.modalService.open(MagnifyFieldSearchComponent, {
      size: 'xl',
      centered: true,
      backdrop: 'static',
      keyboard: false,
    });
    modalRef.componentInstance.fieldMappingDetailId = fieldMappingDetailId;
    modalRef.componentInstance.dependantFieldValues = dependantFieldValues;
    modalRef.componentInstance.selectRecord.subscribe((res) => {
      const selectedField = this.advanceSearchFields.find(
        (x) => x.field_mapping_detail_id == res.fieldId
      );
      selectedField.search_value = res.fieldValue;
      if (selectedField.control_type == 'DROPDOWN') {
        // if dependent field in advance search then add code here
      }
      modalRef.close();
    });
    modalRef.componentInstance.closeModal.subscribe(() => {
      modalRef.close();
    });
  }

  // Grid Data Event//
  advanceSearchCellClick(event: any) {
    if (event.columnName.toLowerCase() == 'action_checkbox_button') {
      if (event.rowData['action_checkbox_button'] == false) {
        if (this.lstDocument_details_id.findIndex(d => d == Number(event.rowData['DOCUMENT_DETAIL_ID'])) == -1) {
          this.lstDocument_details_id.push(Number(event.rowData['DOCUMENT_DETAIL_ID']));
        }
      }
      else {
        if (this.lstDocument_details_id.findIndex(d => d == Number(event.rowData['DOCUMENT_DETAIL_ID'])) > 1) {
          this.lstDocument_details_id.splice(this.lstDocument_details_id.findIndex(d => d == Number(event.rowData['DOCUMENT_DETAIL_ID']), 1))
        }
      }

    }
  }

  getOpenSearchData() {
    let validationStatus: boolean = true;
    let validationMessage: string = '';
    let selectedDocumentTypes: any = [this.selectedDocType];//[];
    let selectedProcessIds: any = [];
    let selectedPriorities: any = [];
    let dateRange: any = { start_date: '', end_date: '' };

    this.ddlPriority.onDropdownOptionClick();
    //this.ddlDocmultiselect.onDropdownOptionClick();
    this.ddlProcessmultiselect.onDropdownOptionClick();

    //selectedDocumentTypes = this.ddlDocmultiselect.selectedValues;
    selectedProcessIds = this.ddlProcessmultiselect.selectedValues;
    selectedPriorities = this.ddlPriority.selectedValues;
    dateRange = {
      start_date: this.commonService.dateFormating(
        this.invoiceCreationDateRange.value.start_date
      ),
      end_date: this.commonService.dateFormating(
        this.invoiceCreationDateRange.value.end_date
      ),
    };

    if (selectedDocumentTypes.length <= 0) {
      validationMessage += '- Please fill the required field(s).\r <br/>';
      validationMessage += '- Select atleast one Work Item Type.\r <br/>';
      validationStatus = false;
    }

    if (!validationStatus) {
      this.commonService.showMessageBox(validationMessage, 'Alert');
      return;
    }

    let searchColumns = {};
    this.advanceSearchFields.forEach((field) => {
      if (field.search_value != '') {
        if (field.control_type == 'DATE') {
          field.search_value = this.commonService.dateFormating(
            field.search_value
          );
        }
        searchColumns[field.db_column_name] = field.search_value.toString();
      }
    });

    let reqData = {
      // project_id: this.commonService.selectedProject,
      // role_id: this.commonService.selectedRole,
      projectId: this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedProject),
      roleId: this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedRole),
      subgroup_id: this.commonService.selectedSubgroup,
      // user_id: this.commonService.getUserInfoFromLocalStorage('userId'),
      // user_id: this.memorystore.getItem('userId'),
      worklist_id: this.selectedWorklistId,
      document_type_ids: this.selectedDocType.toString(),// this.ddlDocmultiselect.selectedValues.toString(),
      process_ids: selectedProcessIds.toString(),
      search_columns: searchColumns,
      priority: selectedPriorities,
      date_range: dateRange,
      urn: this.lstURN,
      invoiceAmountRange: this.invoiceAmount
    };

    this.advanceSearchGridData = [];
    this.dataService.postData('open-search', reqData).subscribe((res) => {
      if (
        res != null &&
        res != undefined &&
        res.data != null &&
        res.data.length > 0
      ) {
        //this.advanceSearchGridData = res.data[0].table_sections[0].section_fields[0];
        // let chk={};
        // chk['action_checkbox_button']=false;
        // chk[0]=res.data[0].table_sections[0].section_fields[0];
        // this.advanceSearchGridData.push(chk);
        //this.lstHeader_search = res.data[0].table_sections
        //this.advanceSearchGridData = res.data[0].table_data;
        let lst = [];
        let obj = {};

        //this.isDisplaySearchGrid = true;
        res.data[0].table_data.forEach(item => {
          obj = {};
          obj['action_checkbox_button'] = false;
          Object.keys(item).forEach(k => {
            obj[k] = item[k];
          })
          lst.push(obj);

        });
        this.advanceSearchGridData = lst;

        if (this.advanceSearchGridData.length <= 0) {
          this.commonService.showMessageBox('No data found', 'Information');
        }
        else {
          this.getdynamicdata();
        }
      }
      else {
        this.commonService.showMessageBox('No data found', 'Information');
      }

    });

  }

  getdynamicdata() {
    this.workItemFieldList = [];

    let params = {
      // project_id: this.commonService.selectedProject,
      // subgroup_id: this.commonService.selectedSubgroup,
      // document_type_id: this.selectedDocType,
      // sub_document_type_id: 0,
      // source: "upload_data",
      project_id: this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedProject),
      subgroup_id: this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedSubgroup),
      // document_type_id: this.selectedDocType,
      // sub_document_type_id: 0,
      source: "upload_data",
    };

    this.dataService.getData('dynamic_fields_subdocType', params).subscribe((res) => {
      //this.dataService.getData('dynamic_fields', params).subscribe((res) => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        if (res.data != null) this.workItemFieldList = res.data;
        else this.workItemFieldList = [];

        this.lstSection = [];
        this.workItemFieldList.forEach(item => {
          if (this.lstSection.findIndex(s => s.SECTION_NAME == item.section_name) == -1) {
            let lst = this.workItemFieldList.filter(x => x.section_name == item.section_name);
            this.lstSection.push({ SECTION_ID: item.section_name, SECTION_NAME: item.section_name, FIELDS_DETAIL: lst, SECTION_ORDER: item.section_order });
          }
        });
        const formControls: any = {};
        this.workItemFieldList.forEach(async (field) => {

          let fieldValidators = [];

          if (field.control_type == 'FILE' || field.is_mandatory == 1) {
            fieldValidators = [Validators.required];
          }

          let defaultValue = field.control_type == 'DATE' ? null : field.control_type == 'DROPDOWN' ? field.dropdown_type == 'PredefinedMst' &&
            field.dropdown_value != null ? +field.dropdown_value.trim() : null : field.control_type == 'CHECKBOX' ? false : '';

          this.db_columns_values_list[field.db_column_name] = defaultValue;

          formControls[field.db_column_name] = new FormControl({ value: defaultValue, disabled: field.is_readonly == 1 }, fieldValidators);

          if (field.control_type == 'TEXTBOX') {
            field.value_type = field.validation_type == 'NUMERIC' ? 'number' : 'text';
          }
          if (field.actions != null) {
            field.actions = JSON.parse(field.actions);
          }
          if (field.control_type == 'DROPDOWN') {
            //By Prakash
            //field.options = JSON.parse(field.options);
            let magnify_dependant_fields = {};
            let dropdown_dependant_parameter = {};
            if (field.magnify_dependant_fields != null && field.magnify_dependant_fields != undefined) {
              magnify_dependant_fields = JSON.parse(field.magnify_dependant_fields);
              Object.keys(magnify_dependant_fields).forEach(x => {

                let field_value = this.db_columns_values_list[magnify_dependant_fields[x]];
                if (field_value != null && field_value != '' && field_value != undefined) {
                  dropdown_dependant_parameter[x] = field_value.toString();
                }
              });
            }
            field.dropdown_dependant_parameter = dropdown_dependant_parameter;

            if (field.is_autocomplete == 0 && field.is_readonly == 0) {
              field.options = await this.commonService.getDropdownData(field.field_mapping_detail_id, 0, dropdown_dependant_parameter);
              //this.db_columns_values_list[field.db_column_name + "_option"] = field.options
            }
            else if (field.is_autocomplete == 0 && field.is_readonly == 1) {
              if (defaultValue != null && defaultValue != undefined)
                field.field_value = defaultValue;
              if (field.field_value == "" || field.field_value == undefined)
                field.field_value = 0;

              field.options = await this.commonService.getDropdownData(field.field_mapping_detail_id, field.field_value, dropdown_dependant_parameter);
            }
            else {
              if (field.field_value == "" || field.field_value == undefined)
                field.field_value = "";

              field.options = await this.commonService.getAutocomplete_dropdowndata(field.field_mapping_detail_id, field.field_value, 'id')
              //this.db_columns_values_list[field.db_column_name + "_option"] = field.options
            }
            //Gabriel start
            //dependant field event called for page load if fields readonly
            if (field.is_dependant == 1 && field.field_value != null) {
              // this.getDependantFields(field.field_mapping_detail_id, fieldVal);                    
              this.getDependantFields(
                field.field_mapping_detail_id, field.field_value
              );
              //field.options = await this.commonService.getDropdownData(field.field_mapping_detail_id, 0, dropdown_dependant_parameter);
              //field.options = await this.commonService.getDropdownData(field.field_mapping_detail_id, field.field_value, dropdown_dependant_parameter);
            }
            //Gabriel end

            //field.options = [...new Map(field.options.map(item => [item['name'], item])).values()];
            // field.options.splice(0, 0, { id: 0, name: '-- Select --' });
          }
        });

        formControls[this.invoiceComment] = new FormControl('', [Validators.required,]);

        if (this.Is_Next_queue_req == true) {
          formControls[this.nextQueue] = new FormControl('', [Validators.required,]);
        }
        this.frmInvoice = new FormGroup(formControls);

        this.getNextQueue();
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.route.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }

    },
    error => {
      if (error.includes("401")) {
        this.route.navigateByUrl('/unauthorized');
        return;
      }
    }
    );
  }

  getNextQueue() {

    this.lstProcess = [];
    this.lstNextQueue = [];
    let params = new HttpParams();
    // params = params.append('project_id', this.commonService.selectedProject);
    params = params.append('project_id', this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedProject));
    params = params.append('xusrid', this.encryptDecryptservice.encryptUsingAES256(this.memorystore.getItem('userId')));
    this.dataService.getData('process-type', params).subscribe((res) => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        if (res.data != null) {
          res.data.forEach((element) => {
            this.lstNextQueue.push({
              process_id: element.process_id,
              process_name: element.process_name,
            });

            this.lstProcess.push({
              value: element.process_id,
              text: element.process_name,
            });
          });
          res.data.forEach((element) => {
            this.lstProcess.push({
              value: element.process_id,
              text: element.process_name,
              selected: true,
            });
          });
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.route.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
    error => {
      if (error.includes("401")) {
        this.route.navigateByUrl('/unauthorized');
        return;
      }
    });
  }

  changeTextFieldValue(field: any) {
    let field_value = this.frmInvoice.get(field.db_column_name).value;

    if (field.is_dependant == 1) {
      this.getDependantFields(
        field.field_mapping_detail_id,
        field_value
      );
    }

    if (field.actions != null) {
      // execute actions/query if any
      field.actions.forEach(action => {
        if (action.action_type == 'SET_VALUE' && action.execute_mode == 'FORMULA' && action.action_trigger == 'VALUE_CHANGE') {
          let formula = action.formula;

          action.formula_fields.split(",").forEach(f => {
            let field_value = this.frmInvoice.get(f).value;
            formula = formula.replace(f, (field_value != "" && field_value != undefined && field_value != null) ? Number(field_value) : 0);
          });
          let formulaValue = eval(formula);

          this.frmInvoice.get(action.target_db_column_name)
            .setValue(formulaValue);
        }
      });
    }

    if (field.validation_type == 'NUMERIC' || field.validation_type == 'AMOUNT') {
      field_value = this.commonService.handleNumberInput(field, field_value);
      this.frmInvoice.get(field.db_column_name).setValue(field_value);
    }

  }

  changeDropdownFieldValue(field: any) {
    if (field.is_dependant == 1) {
      this.getDependantFields(
        field.field_mapping_detail_id,
        this.frmInvoice.get(field.db_column_name).value
      );
    }
  }

  getDependantFields(fieldMappingDetailId: number, selectedValue: any) {
    let params = {
      field_mapping_detail_id: fieldMappingDetailId,
      selected_value: selectedValue,
      xusrid:this.encryptDecryptservice.encryptUsingAES256(this.memorystore.getItem('userId'))
    };

    this.dataService.getData('dependant', params).subscribe((res) => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        if (res != undefined) {
          if (res.data.length > 0) {
            res.data.forEach((ele) => {
              ele.values = JSON.parse(ele.values);
              if (ele.control_type == 'DROPDOWN') {
                const uniqueData = [...new Map(ele.values.map(item => [item['name'], item])).values()];
                this.workItemFieldList.find(
                  (x) => x.db_column_name == ele.db_column_name
                ).options = uniqueData;
                if (uniqueData.length == 1) {
                  this.frmInvoice
                    .get(ele.db_column_name)
                    .setValue(uniqueData[0]['id']);
                }
              } else if (ele.control_type == 'TEXTBOX') {
                if (ele.values.length > 0) {
                  this.frmInvoice
                    .get(ele.db_column_name)
                    .setValue(ele.values[0].name);
                } else {
                  this.frmInvoice.get(ele.db_column_name).setValue('');
                }
              }
            });
          }
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.route.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
    error => {
      if (error.includes("401")) {
        this.route.navigateByUrl('/unauthorized');
        return;
      }
    });
  }

  omit_special_char(e, regExp) {
    // var k;
    // k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    // return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));

    //var regex = new RegExp("^[a-zA-Z0-9 ]+$");
    if (regExp == "" || regExp == null || regExp == undefined)
      return true;

    var regex = new RegExp(regExp);
    var str = String.fromCharCode(!e.charCode ? e.which : e.charCode);
    if (regex.test(str)) {
      return true;
    }

    e.preventDefault();
    return false;
  }

  onTextBoxKeyPressEvent(event: any, field: any) {
    const reg = this.commonService.getRegForDecimal;
    let input = event.target.value + String.fromCharCode(event.charCode);

    if (!reg.test(input)) {
      event.preventDefault();
    }
  }

  openAdvanceSearchModal(fieldMappingDetailId: number, magnifyDependantFields: string = null, predefinedTableColumnName: string = 'id') {

    let dependantFieldValues = {};
    if (magnifyDependantFields != null) {
      magnifyDependantFields = JSON.parse(magnifyDependantFields);
      Object.keys(magnifyDependantFields).forEach(x => {
        let field_value = this.frmInvoice.get(magnifyDependantFields[x]).value;
        if (field_value != null && field_value != '' && field_value != undefined) {
          // let field = this.workItemFieldList.find(f => f.db_column_name == magnifyDependantFields[x]);
          // if (field != undefined && field.control_type == 'DROPDOWN') {
          //   field_value = field.options.find(d => d.id == field_value).name;
          // }
          dependantFieldValues[x] = field_value.toString();
        }
      });
    }

    const modalRef = this.modalService.open(MagnifyFieldSearchComponent, {
      size: 'xl',
      centered: true,
      backdrop: 'static',
      keyboard: false,
    });
    modalRef.componentInstance.fieldMappingDetailId = fieldMappingDetailId;
    modalRef.componentInstance.predefinedTableColumnName = predefinedTableColumnName;
    modalRef.componentInstance.dependantFieldValues = dependantFieldValues;
    modalRef.componentInstance.selectRecord.subscribe((res) => {

      const selectedField = this.workItemFieldList.find(
        (x) => x.field_mapping_detail_id == res.fieldId
      );

      if (selectedField.control_type == 'DROPDOWN') {
        const selectedOptionField = selectedField.options.find(
          (x) => x.id == res.fieldValue
        );
        this.frmInvoice
          .get(selectedField.db_column_name)
          .setValue(selectedOptionField['id']);
        this.changeDropdownFieldValue(selectedField);
      } else if (selectedField.control_type == 'TEXTBOX') {
        this.frmInvoice
          .get(selectedField.db_column_name)
          .setValue(res.fieldValue.toString());
        this.changeTextFieldValue(selectedField);
      }
      modalRef.close();
    });
    modalRef.componentInstance.closeModal.subscribe(() => {
      modalRef.close();
    });
  }

  uploadFileEvt(imgFile: any, controlId: string) {

    this.frmInvoice.controls[controlId].setValue('Choose File');
    if (this.commonService.validateFileUpload(imgFile.target.files[0], this.invoiceDocValidFileExtensions, this.invoiceDocFileSize)) {
      if (imgFile.target.files && imgFile.target.files[0]) {

        let fileName = imgFile.target.files[0].name.split('.').slice(0, -1).join('');
        let fileExt = imgFile.target.files[0].name.split('.').pop();

        this.frmInvoice.controls[controlId].setValue(
          fileName + '.' + fileExt
        );

        let reader = new FileReader();
        reader.onload = (e: any) => {
          this.base64FileString = reader.result.toString();
        };
        reader.readAsDataURL(imgFile.target.files[0]);

        this.fileInput.nativeElement.value = '';
      } else {
        this.frmInvoice.controls[controlId].setValue('Choose File');
      }
    }
    else {
      this.frmInvoice.controls[controlId].setValue('');
      this.base64FileString = '';
    }
  }

  get f() {
    return this.frmInvoice.controls;
  }

  function(data) {
    this.wordsTotal = this.wordsTotal - data.length
  }

  callOnAutoCompleteChangedEvent(data) {
    this.frmInvoice.get(data.db_column_name).setValue(data.fieldValue);
    if (data.control_type == 'DROPDOWN') {
      this.changeDropdownFieldValue(data);
    } else if (data.control_type == 'TEXTBOX') {
      this.changeTextFieldValue(data);
    }
  }

  submitInvoice() {
    this.submitted = true;
    let invalidLengthMsg = "";

    if (this.lstDocument_details_id.length <= 0) {
      this.commonService.showMessageBox("Please select URN(s).", 'Alert');
      this.submitted = false;
      return;
    }

    if (this.frmInvoice.invalid) {
      this.commonService.showMessageBox("Please fill the required field(s).", 'Alert');
      this.submitted = false;

      this.workItemFieldList.forEach(field => {
        this.frmInvoice.controls[field.db_column_name].markAsTouched();
      });
      return;
    }

    let fieldsData = [];
    let lst = [];

    this.workItemFieldList.forEach(field => {

      let formValue = this.frmInvoice.get(field.db_column_name).value;
      let displayText = '';

      if (formValue != undefined && formValue != null)
        formValue = formValue.toString();
      else
        formValue = '';

      // START: field length validation
      if (field.is_readonly == 0 && field.control_type == 'TEXTBOX') {
        let fix_length = 0;
        if (field.min_length == field.max_length) {
          fix_length = field.min_length;
        }

        if (fix_length > 0 && (field.is_mandatory == 1 || formValue != '')) {

          if (formValue.toString().length != fix_length) {
            if (invalidLengthMsg == "")
              invalidLengthMsg = "Length of " + field.field_name + " must be " + fix_length + ".";
            else
              invalidLengthMsg = invalidLengthMsg + "<BR>" + "Length of " + field.field_name + " must be " + fix_length + ".";
          }
        }

        if (fix_length == 0 && field.min_length > 0 && (field.is_mandatory == 1 || formValue != '')) {
          if (formValue.toString().length < field.min_length) {
            if (invalidLengthMsg == "")
              invalidLengthMsg = "Length of " + field.field_name + " is min " + field.min_length + ".";
            else
              invalidLengthMsg = invalidLengthMsg + "<BR>" + "Length of " + field.field_name + " is min " + field.min_length + ".";
          }
        }

        if (fix_length == 0 && field.max_length > 0) {
          if (formValue.toString().length > field.max_length) {
            if (invalidLengthMsg == "")
              invalidLengthMsg = "Length of " + field.field_name + " is up to " + field.max_length + ".";
            else
              invalidLengthMsg = invalidLengthMsg + "<BR>" + "Length of " + field.field_name + " is up to " + field.max_length + ".";
          }
        }
      }
      // END: field length validation

      let value: string = ""

      if (field.control_type == "DATE") {
        value = this.commonService.dateFormating(formValue);
      }
      else {
        value = formValue;
      }

      if (field.control_type == "DROPDOWN") {
        displayText = field.options.find(d => d.id == value)?.name;
      }

      fieldsData.push({
        db_column_name: field.db_column_name,
        field_val: value.toString().trim(),
        controlType: field.control_type,
        displayText: displayText == undefined ? '' : displayText
      });

      lst.push({
        ParameterName: field.db_column_name,
        ParameterValue: value.toString().trim()
      });

    });

    if (invalidLengthMsg != '') {
      this.commonService.showMessageBox(invalidLengthMsg, 'Alert');
      return;
    }

    if (!this.frmInvoice.get(this.invoiceComment).valid) {
      this.commonService.showMessageBox("Please provide comment.", 'Alert');
      return;
    }

    let body = {
      // user_id: Number(this.commonService.getUserInfoFromLocalStorage('userId')),
      user_id: Number(this.memorystore.getItem('userId')),
      fields_data: fieldsData,
      document_detail_id: this.lstDocument_details_id,
      comment: this.frmInvoice.value['invoiceComment'],
      next_queue_id: this.Is_Next_queue_req == true ? (Number(this.frmInvoice.get(this.nextQueue).value)):0,
    };

    this.dataService.postData('updatedata', body).subscribe((res) => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        if (res != undefined && res.status == true) {
          this.commonService.showMessageBox("URN(s) updated successfully.", 'Message');
          this.ClearOpenSearch();
        } else {
          this.commonService.showMessageBox(res.error_message, 'Alert');
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.route.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
    error => {
      if (error.includes("401")) {
        this.route.navigateByUrl('/unauthorized');
        return;
      }
    });
  }

  ClearOpenSearch() {
    this.advanceSearchFields.forEach((field) => {
      field.search_value = '';
    });

    this.frmInvoice = null;

    this.lstURN = '';
    this.invoiceAmount = '';
    this.advanceSearchGridData = [];
    this.submitted = false;
    this.strComments = "";

    if (this.ddlDocmultiselect != undefined && this.ddlDocmultiselect != null) {
      this.ddlDocmultiselect.allSelected = true;
      this.ddlDocmultiselect.ngAfterViewInit();
    }

    if (this.ddlPriority != undefined && this.ddlPriority != null) {
      this.ddlPriority.allSelected = true;
      this.ddlPriority.ngAfterViewInit();
    }

    if (this.ddlProcessmultiselect != undefined && this.ddlProcessmultiselect != null) {
      this.ddlProcessmultiselect.allSelected = true;
      this.ddlProcessmultiselect.ngAfterViewInit();
    }

    this.invoiceCreationDateRange = new FormGroup({
      start_date: new FormControl(),
      end_date: new FormControl(),
    });

    this.isDateRangeHasValue = false;

    this.lstSection = [];
    this.workItemFieldList = [];
  }

  showModal(modelTemplate, modalSize: string = 'lg') {
    this.modalReference = this.modalService.open(modelTemplate, {
      size: modalSize, centered: true, backdrop: 'static',
      keyboard: false
    });
  }

  onInvoiceCreationDateChanges() {
    if (
      this.invoiceCreationDateRange.value.start_date != '' ||
      this.invoiceCreationDateRange.value.end_date != ''
    ) {
      this.isDateRangeHasValue = true;
    }
  }

  resetInvoiceCreationDateRange() {
    this.invoiceCreationDateRange = new FormGroup({
      start_date: new FormControl(),
      end_date: new FormControl(),
    });
    this.isDateRangeHasValue = false;
  }

  setDecimalPlaces(value: any, decimalPlace: number, validationType: string) {
    return validationType.toLowerCase() == 'numeric' ? parseFloat(value == '' ? 0 : value).toFixed(Number(decimalPlace)) : value;
  }

  checkRestrictedKeywords(formControlName: string) {
    let foundedRestrictedKeyword = [];
    let input = this.frmInvoice.get(formControlName).value;
    this.restrictedKeywords.forEach((keyword) => {
      if (input.includes(keyword.restrict)) {
        input = input.replaceAll(keyword.restrict, keyword.replace);
        foundedRestrictedKeyword.push(keyword.restrict);
      }
    });
    if (foundedRestrictedKeyword.length > 0) {
      this.frmInvoice.get(formControlName).setValue(input);
      this.commonService.showMessageBox(
        'We found some restricted keyword(s) entered in Comment.<br>It auto replaced by replacement keywords.<br>Please check given link for restricted keywords.',
        'Warning'
      );
    }
  }
}
